<template>
  <div class="tw-bg-[#252f4a] tw-text-white tw-px-10 tw-py-10">
    <!-- Disclaimer -->
    <div>
      <p class="tw-text-xl tw-font-bold">
        Disclaimer
      </p>
      <div class="tw-text-xs tw-flex tw-flex-col tw-gap-1.5">
        <p>
          Stake PBC is not an investment advisor, and does not provide investment advice or investment recommendations.
          The information contained herein is believed to be from reliable sources,
          but we make no warranty or guarantee as to the accuracy of the information.
          Information provided is as of {{ (new Date()).toLocaleDateString() }},
          and may change over time based on market or other conditions.
        </p>
        <p>
          Investing involves risk.
          Depending on the types of investments, there may be varying degrees of risk.
        </p>
        <p>
          Portfolio chat functionality is provided strictly as a courtesy.
          We make no representation as to the completeness or accuracy of information provided in chat responses.
          Chat responses should not be considered financial advice.
          Stake is not liable for any inaccurate or incomplete responses provided by the chat.
          This feature is currently optimized for portfolios with fewer than 30 holdings.
          If your portfolio exceeds this size, the tool may not function as intended or may produce inaccurate information.
        </p>

        <p>
          Any tradelists are provided for informational purposes and are not intended for trade execution.
          In no way is Stake providing investment recommendations.
        </p>
      </div>
      <br>
    </div>

    <!-- Firm Specific Disclosures -->
    <div v-if="advisorStore.advisor?.firm?.advisorcore_compliance_language">
      <p class="tw-text-xl tw-font-bold">
        {{ advisorStore.advisor?.firm?.name }} Disclosures
      </p>
      <div class="tw-text-xs">
        <p>
          {{ advisorStore.advisor?.firm?.advisorcore_compliance_language }}
        </p>
      </div>
      <br>
    </div>

    <!-- Methodology -->
    <div v-if="$slots.default">
      <p class="tw-text-xl tw-font-bold">
        Methodology
      </p>
      <div class="tw-text-xs">
        <slot />
      </div>
    </div>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';

export default {
  name: 'CheckupDisclaimer',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>

</style>
